export const findIndex = (arr: any, value: string) => {
  return arr.findIndex((link: any) => link?.title === value);
};

export const titleCase = (word: string) => {
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
};

export const isValidUrl = (urlString: string) => {
  try {
    return new URL(urlString);
  } catch (e) {
    return `/${urlString}`;
  }
};

